let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5j5Gk"), load("f7AoK")]).then(() => parcelRequire('9XhDi'));